/**
 * PATCH `admin/clinic-applications/:id/status` — смена статуса заявки.
 * Переходы свободные (решение можно пересмотреть); BE запоминает кто/когда
 * и пишет действие в аудит. Ответ — обновлённая заявка.
 */

import {apiEnabled, http} from '@services/utils';

import {applyStatusMock} from '../mocks';
import {toApplicationItem} from '../toApplicationItem';
import type {ApplicationItem, SetApplicationStatusInput} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const setApplicationStatus = async (
  input: SetApplicationStatusInput,
): Promise<ApplicationItem | null> => {
  if (!apiEnabled) {
    await sleep(350);
    return applyStatusMock(input.id, input.status);
  }

  const raw = await http<Record<string, unknown>>(
    `admin/clinic-applications/${encodeURIComponent(input.id)}/status`,
    {method: 'PATCH', body: {status: input.status}, skipCaseConversion: true},
  );
  return toApplicationItem(raw);
};
